export default __webpack_public_path__ + "images/3ddf03b88096f7d5165a0a20dbb5c5de-logo-paketa-horizontal.png";